import React from "react";
import { Table } from "antd";

const DataTable = ({
  dataSource = [],
  columns = [],
  subTableConfig = {},
  hasSubTable = false,
  rowKey = "_id",
  headingBgColor = "#DDE1E6",
  headingTextColor = "#4772F1",
}) => {
  const expandable = subTableConfig.expandedRowRender
    ? {
        expandedRowRender: subTableConfig.expandedRowRender,
        rowExpandable: subTableConfig.rowExpandable || (() => true),
        expandIcon: ({ expanded, onExpand, record }) => (
          <div
            onClick={(e) => onExpand(record, e)}
            className="w-3 h-3 md:w-4 md:h-4 lg:w-5 lg:h-5 flex items-center justify-center border border-[#4772F1] rounded-[4px] cursor-pointer hover:shadow-md transition-all bg-white"
          >
            <span className="text-[#757575] text-[10px] sm:text-[14px] md:text-[18px] lg:text-[24px] flex items-center justify-center sm:pb-1 select-none">
              {expanded ? "-" : "+"}
            </span>
          </div>
        ),
      }
    : hasSubTable
    ? {
        expandedRowRender: (record) => (
          <Table
            columns={subTableConfig.columns || []}
            dataSource={record[subTableConfig.dataField] || []}
            pagination={false}
            size="small"
            rowKey={(item, index) =>
              `${record[rowKey]}-${item.referenceId || item.date || index}`
            }
            components={{
              body: {
                cell: (props) => (
                  <td
                    {...props}
                    className="text-[#707070] font-inter text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] font-normal px-2 py-2 whitespace-normal break-words"
                  >
                    {props.children}
                  </td>
                ),
              },
            }}
          />
        ),
        // rowExpandable: (record) => record.payments?.length > 0,
        //rowExpandable: () => true,
        rowExpandable: (record) => record[subTableConfig.dataField]?.length > 0,
        expandIcon: ({ expanded, onExpand, record }) => (
          <div
            onClick={(e) => onExpand(record, e)}
            className="w-3 h-3 md:w-[16px] md:h-[16px] lg:w-[20px] lg:h-[20px] flex items-center justify-center border border-[#4772F1] rounded-[4px] cursor-pointer hover:shadow-md transition-all bg-white"
          >
            <span className="text-[#757575] text-[10px] sm:text-[14px]  md:text-[18px] lg:text-[24px] flex items-center justify-center sm:pb-1  select-none ">
              {expanded ? "-" : "+"}
            </span>
          </div>
        ),
      }
    : undefined;

  return (
    <div className="w-full p-0">
      <div className="overflow-x-auto border border-[#E5E5E5]">
        <Table
          columns={columns}
          dataSource={dataSource}
          scroll={{ x: "max-content" }}
          expandable={expandable}
          pagination={false}
          bordered={false}
          rowKey={rowKey}
          components={{
            header: {
              cell: (props) => (
                <th
                  {...props}
                  className={`text-[#4772F1] font-bold font-inter h-[46px] text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] px-3 py-2`}
                  style={{
                    background: "linear-gradient(180deg, rgba(229, 240, 255, 0.1764) 0%, rgba(135, 63, 226, 0.0784) 100%)",
                    fontWeight: 700,
                    color: headingTextColor,
                    height: "46px",
                    borderTopLeftRadius:
                      props["data-index"] === "id" ? "8px" : 0,
                    borderTopRightRadius:
                      props["data-index"] === "actions" ? "8px" : 0,
                    ...props.style,
                  }}
                />
              ),
            },
            body: {
              cell: (props) => (
                <td
                  {...props}
                  className="text-[#707070] font-sans leading-5 text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] font-[400] tracking-[0%]  px-4 py-2"
                >
                  {props.children}
                </td>
              ),
            },
          }}
        />
      </div>
    </div>
  );
};

export default DataTable;
